export { default } from "./Form3";
export { default as Form3 } from "./Form3";
export * from "./types";
export * from "./hooks";
export * from "./utils";
export * from "./constants";
export * from "./components";

// Direct hook export for convenience
export { useForm3 } from "./hooks";

